<template>
  <section class="full-image" data-responsive-background-image>
    <div class="mask" v-if="$props.heading">
      <h2>{{ $props.heading }}</h2>
    </div>
    <img 
      :srcset="imageSet" 
      :src="$props.image"
    >
  </section>
</template>

<script>
import ResponsiveBackgroundImage from 'lib/responsiveImage.js'

export default {
  data: function () {
    return {
      imageSet: ''
    }
  },
  props: {
    href: String,
    image: String,
    mobileImage: String,
    heading: String
  },
  mounted: function () {
    let elements = document.querySelectorAll('[data-responsive-background-image]');
    for (let i = 0; i < elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }

    if(this.$props.mobileImage && this.$props.image) {
      this.imageSet = this.$props.mobileImage + ' 800w, ' + this.$props.image + ' 1600w'
    }

  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.full-image {
  max-height: 25rem;
  height: 25rem;
  width: 100%;
  position: relative;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: $col_thirdopacity;
}

h2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: $col_white;
  font-weight: 700;
  text-shadow: #000 0px 2px 4px;
  text-align: center;
}

[data-responsive-background-image] {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
}

[data-responsive-background-image] img {
  display: none;
}

@media #{$desktop} {

  .full-image {
    max-height: 40rem;
    height: 40rem;
  }
}

</style>